export default "__VITE_ASSET__Bs9r0_I7__"